<div
  class="top-gap centered-container"
  fxLayout="column"
  fxLayoutAlign="start center"
>
  <app-my-profile-incomplete></app-my-profile-incomplete>
  <div fxLayout="column" fxLayoutGap="12px" fxFill>
    <app-services-search
      (providerTypes)="providerTypes$.next($event)"
      (searchString)="searchString$.next($event)"
    ></app-services-search>
    <app-loading-spinner
      class="results-spinner"
      [(show)]="resultsLoading"
    ></app-loading-spinner>
    <app-service-result
      *ngFor="let serviceResult of serviceResults"
      [result]="serviceResult"
    ></app-service-result>
  </div>
</div>
